import React, { useEffect, useState } from 'react';

import ProcurementCategoriesForm from '../../procurement_categories/ProcurementCategoriesForm';
import { useProcurement } from '../context/ProcurementContext';

import CategoryTile from './CategoryTile';
import NewTile from './NewTile';
import SlideOver from './SlideOver';

import { apiClient } from 'Helpers/network';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

/**
 * IB-701 — Setup > Categories grid. Tiles show real category data (name, linked-procurement count
 * and total value) with an auto icon colour/code. Clicking a tile or the "+ New category" tile
 * opens the EXISTING category form inside a slide-over; the grid refetches on save. No colour
 * picker — the form has no colour field and this keeps it that way.
 */
const CategoryTiles = () => {
    const { settings, routes } = useProcurement();
    const currencySymbol = settings.currencySymbol;

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(null); // { mode: 'create'|'update', category }

    const fetchCategories = () => {
        setLoading(true);
        apiClient
            .get(routes.fetchCategoriesUrl)
            .then(({ data }) => setCategories(data?.categories ?? []))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const closeSlideOver = () => setEditing(null);

    const onSaved = () => {
        closeSlideOver();
        fetchCategories();
    };

    const isCreate = editing?.mode === 'create';

    return (
        <>
            {loading && !categories.length ? (
                <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
                    <LoadingSpinner />
                </div>
            ) : (
                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-3">
                    {categories.map((category) => (
                        <CategoryTile
                            key={category.id}
                            category={category}
                            currencySymbol={currencySymbol}
                            onClick={() => setEditing({ mode: 'update', category })}
                        />
                    ))}
                    <NewTile label={$t('New category')} onClick={() => setEditing({ mode: 'create', category: {} })} />
                </div>
            )}

            <SlideOver isOpen={!!editing} onClose={closeSlideOver} title={isCreate ? $t('New category') : $t('Edit category')}>
                {editing && (
                    <ProcurementCategoriesForm
                        category={editing.category}
                        action={isCreate ? 'create' : 'update'}
                        updateUrl={isCreate ? routes.createCategoryUrl : routes.updateCategoryUrl}
                        internalCloseHandler={closeSlideOver}
                        setCategoryIsUpdated={onSaved}
                        request={false}
                    />
                )}
            </SlideOver>
        </>
    );
};

export default CategoryTiles;
